import { Col, Divider, Pagination, Row } from "antd";
import CustomNoData from "apps/Common/CustomNoData";
import AdvertListViewSkelton from "apps/Common/Skelton/AdvertListViewSkelton";
import RealStateListViewItem from "apps/RealState/Common/ListViewItem";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetUserAdverts } from "../ServerSideStates";
import { handleSetPortofolioFilter } from "../ClientSideStates";

const RealStateListItems = () => {
  const { filter } = useSelector((state: RootState) => state.portofolio);
  const adverts = useGetUserAdverts(filter);
  console.log("GetUserAdvertList", filter);
  const dispatch = useDispatch();

  const handleChangePagination = (pageNum: number, pageSize: number) => {
    let newFilter = { 
      ...filter, 
      PageIndex: pageNum, 
      PageSize: pageSize 
    };
    dispatch(handleSetPortofolioFilter({ filter: newFilter }));
  };

  // ✅ Client-side sıralama: insertDate'e göre DESC
  const sortedDataList = [...(adverts?.data?.data?.data || [])].sort((a, b) => {
    return new Date(b.insertDate).getTime() - new Date(a.insertDate).getTime();
  });

  return (
    <>
      <Row gutter={[0, 20]} className="!mt-6">
        <Col span={24}>
          <Row justify="space-between" gutter={[40, 40]}>
            <AdvertListViewSkelton
              count={4}
              customGutter={[40, 20]}
              loading={adverts.isLoading || adverts.isFetching}
            >
              <>
                {sortedDataList.length > 0 ? (
                  <>
                    {sortedDataList.map((item: any, index: number) => (
                      <React.Fragment key={index}>
                        <Col xs={24} className="hover:cursor-pointer">
                          <RealStateListViewItem
                            pageType="portfolio"
                            item={item}
                            advertType={item.type === 0 ? "realState" : "vehicle"}
                          />
                        </Col>
                      </React.Fragment>
                    ))}

                    <Col
                      xs={24}
                      className="!flex !justify-center md:!justify-end"
                    >
                      <Pagination
                        onChange={handleChangePagination}
                        total={adverts?.data?.data?.filteredCount || 0}
                        pageSize={adverts?.data?.data?.pageSize || 20}
                        current={adverts?.data?.data?.pageIndex || 1}
                        showLessItems={true}
                        size={"small"}
                        showSizeChanger={true}
                        locale={{ items_per_page: "" }}
                        showTotal={(e) => `${e}`}
                        className="!px-0"
                      />
                    </Col>
                  </>
                ) : (
                  <CustomNoData />
                )}
              </>
            </AdvertListViewSkelton>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default RealStateListItems;
